import { render, staticRenderFns } from "./AgregarCuenta.vue?vue&type=template&id=56cf8bd2&"
import script from "./AgregarCuenta.vue?vue&type=script&lang=js&"
export * from "./AgregarCuenta.vue?vue&type=script&lang=js&"
import style0 from "./AgregarCuenta.vue?vue&type=style&index=0&id=56cf8bd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports